import { RelationshipsItem, RelationshipsRequest } from '../components/DatasetRelationships/relationships.types'
import { PRIVATE_BASE_URL } from '../../../../../configs'
import api from '../../../../../services/api'

export const getRelations = (datasetId: string): Promise<RelationshipsItem[]> => {
  return api.get(`${PRIVATE_BASE_URL}/bot/datasets/${datasetId}/relation`)
}

export const postRelation = (datasetId: string, body: RelationshipsRequest): Promise<RelationshipsItem> => {
  return api.post(`${PRIVATE_BASE_URL}/bot/datasets/${datasetId}/relation`, body)
}

export const deleteRelation = (datasetId: string, relationId: string): Promise<RelationshipsItem> => {
  return api.delete(`${PRIVATE_BASE_URL}/bot/datasets/${datasetId}/relation/${relationId}`)
}

export const putRelation = (datasetId: string, relationId: string, body: RelationshipsRequest): Promise<RelationshipsItem> => {
  return api.put(`${PRIVATE_BASE_URL}/bot/datasets/${datasetId}/relation/${relationId}`, body)
}

export const datasetRelationService = {
  getRelations,
  postRelation,
  deleteRelation,
  putRelation
}
